import _ from "lodash";

import { formDataToStructuredObject } from "utils/formDataUtils";
import { PaymentSourceInputName } from "v2/dataroutes/BillingData";


// TODO these types below should come from a Billing Service type library
type PaymentSourceBase = {
  id: string;
  isPrimary: boolean;
};

export type CardPaymentSource = PaymentSourceBase & {
  type: "card";
  brand: string;
  last4: string;
  expiry: {
    month: number;
    year: number;
  };
  nameOnCard?: string;
};

export type PayPalPaymentSource = PaymentSourceBase & {
  type: "paypal";
  paypalEmail: string | undefined;
};


export type PaymentSource = CardPaymentSource | PayPalPaymentSource;


type PaymentSourceRequestBase = {
  id: string | undefined;
};

type PayPalPaymentSourceRequest = PaymentSourceRequestBase & {
  type: "paypal";
  billing_agreement_token: string;
};

type CardPaymentSourceRequest = PaymentSourceRequestBase & {
  type: "card";
  number?: string;
  cvv?: string;
  expiry: {
    year: string;
    fullYear: string;
    month: string;
  };
  name_on_card?: string;
};

export type PaymentSourceRequest = CardPaymentSourceRequest | PayPalPaymentSourceRequest;


export function getPaymentSourceTitle(paymentSource: PaymentSource): string {
  if (paymentSource.type === "card") {
    return _.startCase(paymentSource.brand) + " ending in " + paymentSource.last4;
  } else if (paymentSource.type === "paypal") {
    return paymentSource.paypalEmail ? `PayPal (${paymentSource.paypalEmail})` : "PayPal";
  }

  throw new Error("Unsupported payment source type");
}

export function toPaymentSourceRequest(formData: FormData): PaymentSourceRequest {
  const formDataObj = formDataToStructuredObject(formData);

  switch (formDataObj[PaymentSourceInputName.type]) {
    case "card":
      return {
        id: _.get(formDataObj, PaymentSourceInputName.id),
        type: "card",
        number: _.get(formDataObj, PaymentSourceInputName.card.number),
        cvv: _.get(formDataObj, PaymentSourceInputName.card.cvv),
        expiry: {
          year: _.get(formDataObj, PaymentSourceInputName.card.expiry.year),
          fullYear: _.get(formDataObj, PaymentSourceInputName.card.expiry.fullYear),
          month: _.get(formDataObj, PaymentSourceInputName.card.expiry.month)
        },
        name_on_card: _.get(formDataObj, PaymentSourceInputName.card.nameOnCard) || undefined
      };

    case "paypal":
      return {
        id: _.get(formDataObj, PaymentSourceInputName.id),
        type: "paypal",
        billing_agreement_token: _.get(formDataObj, PaymentSourceInputName.paypal.billingAgreementToken)
      };
  }

  throw new Error("Unsupported payment source type");
}
